// extracted by mini-css-extract-plugin
export default {"input":"AdminMobileSearchInput_input__a5f88","search":"AdminMobileSearchInput_search__K6XrD"};